import GlobalHelper from "../common/GlobalHelper"
import { Intl } from "../state/helpers/IntlProps"
import { defineMessages } from "react-intl"

const messages = defineMessages({
    "registration_form": {
        id: "lsgolf_registration",
        defaultMessage: "registration form",
    },
    "price_list": {
        id: "price_list_label_lowercase",
        defaultMessage: "price list",
    },
})

export function getPriceListName(intl: Intl): string {
    const hasLSGolfIntegration = GlobalHelper.hasGolfIntegration()
    if (hasLSGolfIntegration) {
        return intl.formatMessage(messages["registration_form"])
    }
    return intl.formatMessage(messages["price_list"])
}



// WEBPACK FOOTER //
// ./src/name-helpers/priceListNameHelper.tsx